var map = {
	"./1.png": 833,
	"./Access to ambulance.png": 834,
	"./Adventure.png": 835,
	"./Airline _ Car Rental.png": 836,
	"./Arrangement for Compassionate visit.png": 837,
	"./Arrangement of return of minor.png": 838,
	"./Assistance on Currency and ATM Location.png": 839,
	"./Automated baggage tracking service.png": 221,
	"./Automated flight tracking assistance.png": 840,
	"./Baggage Lost_ Delay benefit.png": 841,
	"./Battery Jump Start.png": 842,
	"./Chauffer Service.png": 843,
	"./Delivery Of medicine.png": 844,
	"./Doctor on call assistance.png": 845,
	"./Embassy Referral.png": 846,
	"./Emergency Document delivery.png": 847,
	"./Emergency Message Transmission Assistance.png": 848,
	"./Exchange rate information Assistance.png": 849,
	"./Financial Emergency Assistance.png": 850,
	"./Flat Tyre Assistance.png": 851,
	"./Flight Delay_ Cancellation.png": 852,
	"./Flowers and gift delivery.png": 853,
	"./Global Airport Transfer.png": 854,
	"./Golf Cover.png": 855,
	"./Hazard Information.png": 856,
	"./Home Diagnostic Service.png": 857,
	"./Home Health Care Service.png": 858,
	"./Inoculation Info.png": 859,
	"./Interpreter and Translation Service.png": 860,
	"./Key_ Lock Loss.png": 861,
	"./Legal Assistance.png": 862,
	"./Location Information.png": 863,
	"./Loss of Driving License.png": 864,
	"./Lost Travel Document _ Credit Card  Assistance.png": 865,
	"./Medical E prescription.png": 866,
	"./Medical Evacuation.png": 867,
	"./Medical Referral service.png": 868,
	"./Medical translation service.png": 869,
	"./Minor Repairs.png": 870,
	"./Pet Cover.png": 871,
	"./Religious Service Information Assistance.png": 872,
	"./Repatriation Assistance.png": 873,
	"./Restaurant information.png": 874,
	"./Seat Bump.png": 875,
	"./Towing Assistance.png": 876,
	"./Visa information.png": 877,
	"./Weather _ Climate Information Assistance.png": 878
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 832;